import SizesZone from 'components/Catalog/ProductGrid/CompareModal/Zones/SizesZone/SizesZone';

export default SizesZone;
